<template>
    <div></div>
</template>

<script>
export default {
  name: 'User',
  data () {
    return {
      isLoaded: false
    }
  }
}
</script>
